module.exports = __webpack_public_path__ + "img/nav_footer_3.ca50cdfd.png";